import { SUBMITTING_SIGN_IN, SIGN_IN_SUCCESS, SIGN_IN_FAILURE, RESET_SIGN_IN } from '../constants/action_types';
import { authenticate } from '../api/api';
import has from 'lodash/has';

const submittingSignIn = () => ({
    type: SUBMITTING_SIGN_IN
});

const signInSuccess = (data) => ({
    type: SIGN_IN_SUCCESS,
    data
});

const signInFailure = () => ({
    type: SIGN_IN_FAILURE
});

const resetSignIn = () => ({
    type: RESET_SIGN_IN
});

const submitSignIn = (data, redirectTo = null) => dispatch => {
    dispatch(submittingSignIn());

    return authenticate(data)
        .then(res => {
            if (!res.ok) {
                return dispatch(signInFailure());
            }

            if (has(res.headers, 'x-redirect-location')) {
                return window.location.replace(res.headers['x-redirect-location']);
            }

            return window.location.replace(Router.generate(redirectTo ? redirectTo : 'account_dashboard'));
            // return dispatch(signInSuccess(res.body));
        })
        .catch(error => {
            return dispatch(signInFailure());
        });
};

export {
    submitSignIn,
    resetSignIn
};
